export default __webpack_public_path__ + "static/media/google.35146786.png";